import { render, staticRenderFns } from "./key.vue?vue&type=template&id=824c6108&scoped=true&"
import script from "./key.vue?vue&type=script&lang=js&"
export * from "./key.vue?vue&type=script&lang=js&"
import style0 from "./key.vue?vue&type=style&index=0&id=824c6108&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "824c6108",
  null
  
)

export default component.exports